import { z } from "zod";

// @ts-ignore
export const PaymentTypeSchema = z.enum(["CREDIT_CARD", "PAY_BY_INVOICE"]);

export const PaymentInstrumentSchema = z.object({
  paymentType: PaymentTypeSchema,
  paymentInstrumentId: z.string(),
});

export const CustomerSchema = z.object({
  customerId: z.string(),
  addressId: z.string(),
  paymentInstruments: z.array(PaymentInstrumentSchema),
});

export const OrderItemSchema = z.object({
  merchantId: z.string(),
  asin: z.string(),
  sku: z.string(),
  quantity: z.number(),
});

export const CreateOrderRequestSchema = z.object({
  marketplaceId: z.string(),
  realm: z.string().nullable().optional(),
  customer: CustomerSchema,
  orderItems: z.array(OrderItemSchema),
  shipOption: z.string().nullable().optional(),
  abGroupId: z.string(),
});
export type CreateOrderRequest = z.infer<typeof CreateOrderRequestSchema>;

export const CreateOrderResponseSchema = z.object({
  orderId: z.string(),
  purchaseId: z.string(),
  orderItemIds: z.array(z.string()),
});
export type CreateOrderResponse = z.infer<typeof CreateOrderResponseSchema>;
